module.exports = __webpack_public_path__ + "img/ilk_7.b8f4147e.png";